__turbopack_context__.v({
  "actions": "RepairDetailsSection-module-scss-module__JRQ8IW__actions",
  "card": "RepairDetailsSection-module-scss-module__JRQ8IW__card",
  "changeButton": "RepairDetailsSection-module-scss-module__JRQ8IW__changeButton",
  "content": "RepairDetailsSection-module-scss-module__JRQ8IW__content",
  "error": "RepairDetailsSection-module-scss-module__JRQ8IW__error",
  "optionRow": "RepairDetailsSection-module-scss-module__JRQ8IW__optionRow",
  "section": "RepairDetailsSection-module-scss-module__JRQ8IW__section",
  "sectionHint": "RepairDetailsSection-module-scss-module__JRQ8IW__sectionHint",
  "title": "RepairDetailsSection-module-scss-module__JRQ8IW__title",
});
